import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { useNewbuildingPurchaseGiftPromo } from './NewbuildingPurchaseGiftPromoContext';
import { NewbuildingPurchaseGiftSidebarTongue } from '../../components/NewbuildingPurchaseGiftSidebarTongue';
import { NEWBUILDING_PURCHASE_GIFT_ENTRY_POINT_TEXT } from '../../constants/newbuildingPurchaseGiftPromo';

export const NewbuildingPurchaseGiftSidebarTongueContainer: React.FC = () => {
  const { isAvailable, openModal, trackSidebarShow } = useNewbuildingPurchaseGiftPromo();

  const handleClick = React.useCallback(() => openModal('sidebar'), [openModal]);

  if (!isAvailable) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackSidebarShow} triggerOnce wrapper={false}>
      <NewbuildingPurchaseGiftSidebarTongue text={NEWBUILDING_PURCHASE_GIFT_ENTRY_POINT_TEXT} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
